import React from "react"
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react"
import { Flex, Input, Typography, Select, DatePicker, Button, Card, Form } from "antd"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { packetsTrainingsAction } from "src/store/Slices/Administrator/PacketsTrainingsSlice"
import { openNotification } from "src/components/helpers/notification"
import { getTrainers } from "src/store/Slices/DropDownSlice"
import dayjs from "dayjs"
import { PlusOutlined } from "@ant-design/icons"

const AddEditPacketsTrainingsModal = ({
  visible,
  setVisible,
  packetsTrainingsInfo,
  setPage,
  setPageSize,
}) => {
  const dispatch = useDispatch()

  const [month, setMonth] = useState()
  const [trains, setTrains] = useState()
  const [trainer, setTrainer] = useState()
  const [price, setPrice] = useState()
  const [buyFrom, setBuyFrom] = useState()
  const [buyTo, setBuyTo] = useState()

  const trainers = useSelector((state) => state.DropDownSlice.trainersList)

  useEffect(() => {
    setMonth()
    setTrains()
    setTrainer()
    setPrice()
    setBuyFrom()
    setBuyTo()
  }, [visible.flag])

  useEffect(() => {
    if (visible.flag === "edit") {
      setTrainer(
        trainers?.data?.value.find(
          (el) => el.label === packetsTrainingsInfo?.employ
        )?.value
      )
      setMonth(packetsTrainingsInfo?.monthsActive)
      setTrains(packetsTrainingsInfo?.numberOfTrainings)
      setPrice(packetsTrainingsInfo?.price)
      setBuyFrom(packetsTrainingsInfo?.buyableFrom)
      setBuyTo(packetsTrainingsInfo?.buyableTo)
    }
  }, [visible, packetsTrainingsInfo])

  useEffect(() => {
    dispatch(getTrainers())
  }, [visible])

  const onClickSubmit = () => {
    !(trainer && trains && price)
      ? openNotification({
          type: "error",
          message: `Заполните первые три поля`,
        })
      : console.log(buyFrom, buyTo)
    dispatch(
      packetsTrainingsAction({
        flag: visible.flag === "add" ? "put" : "post",
        value: {
          id: visible.flag !== "add" ? packetsTrainingsInfo.id : undefined,
          employId: trainer,
          monthsActive: month,
          numberOfTrainings: trains,
          price: price,
          buyableFrom: buyFrom ? dayjs(buyFrom).add(1, "day") : undefined,
          buyableTo: buyTo ? dayjs(buyTo).add(1, "day") : undefined,
        },
      })
    ).then(() => {
      dispatch(packetsTrainingsAction({ flag: "get" })).then(() => {
        setVisible({ open: false, flag: "" })
        setPage(1)
        setPageSize(20)
      })
    })
  }

  return (
    <CModal
      alignment='center'
      visible={visible.open}
      aria-labelledby='VerticallyCenteredExample'
      onClose={() => {
        setVisible({ open: false, flag: "" })
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id='VerticallyCenteredExample'>
          {visible.flag === "add" ? "Добавить пакет" : "Редактировать пакет"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Тренер</Typography.Title>
              <Select
                style={{ width: "100%" }}
                placeholder='Выбрать'
                onClick={() => {
                  visible.flag === "add" && dispatch(getTrainers())
                }}
                value={trainer}
                onChange={(e) => {
                  setTrainer(e)
                }}
                options={trainers?.data?.value}
              />
            </div>

            <div>
              <Typography.Title level={5}>Число тренировок</Typography.Title>
              <Input
                value={trains}
                type='number'
                onChange={(e) => setTrains(e.currentTarget.value)}
              />
            </div>
            <div>
              <Typography.Title level={5}>Цена</Typography.Title>
              <Input
                value={price}
                type='number'
                onChange={(e) => setPrice(e.currentTarget.value)}
              />
            </div>
            
            <div>
              <Typography.Title level={5}>Число месяцев</Typography.Title>
              <Input
                value={month}
                type='number'
                onChange={(e) => setMonth(e.currentTarget.value)}
              />
            </div>
            <div>
              <Typography.Title level={5}>Покупаемо с</Typography.Title>
              <DatePicker
                placeholder='Выбрать дату'
                onChange={(date) => {
                  setBuyFrom(date) // wrap in array
                  // confirm();
                }}
                onPressEnter={() => confirm()}
                value={buyFrom ? dayjs(buyFrom) : ""}
                style={{
                  marginBottom: 8,
                }}
              />
            </div>
            <div>
              <Typography.Title level={5}>Покупаемо до</Typography.Title>
              <DatePicker
                placeholder='Выбрать дату'
                onChange={(date) => {
                  setBuyTo(date) // wrap in array
                }}
                onPressEnter={() => confirm()}
                value={buyTo ? dayjs(buyTo) : ""}
                style={{
                  marginBottom: 8,
                }}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible({ open: false, flag: "" })
          }}
          className='text-light'
          color='secondary'
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickSubmit} className='text-light'>
          {visible.flag === "add" ? "Добавить" : "Редактировать"}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default AddEditPacketsTrainingsModal
